import { useState, useEffect, useCallback } from 'react';

/**
 * A hook that constructs intro messages for brochures containing hotels, cars, and flights
 * based on the provided itinerary data, while also managing extraction triggers and errors.
 */
const useBrochureExtractor = ({ emailMessage, generalInfo }) => {
  const [introMessage, setIntroMessage] = useState();
  const [error, setError] = useState(null);
  const [extractTriggered, setExtractTriggered] = useState(false);
  const extractHeadersSections = useCallback((start, end) => emailMessage && emailMessage.split('\n\n').slice(start, end).join('\n'), [emailMessage]);
  const instruction = `${extractHeadersSections(0, 2) || ''}\n\n${generalInfo}\n\n${extractHeadersSections(2)}`;
  useEffect(() => {
    if (extractTriggered) {
      setExtractTriggered(false);
      setIntroMessage(instruction);
    }
  }, [extractHeadersSections, extractTriggered, instruction, setIntroMessage]);

  return {
    introMessage,
    triggerExtract: setExtractTriggered,
    extractorError: error,
    setExtractorError: setError,
  };
};

export default useBrochureExtractor;
